const bookSizeDialogStyle = (theme) => ({
  bookTiles: {

  },

  bookTile: {
    background: 'transparent',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',

    '.MuiCardActionArea-root': {
      padding: 8
    },

    '&.active': {
      borderColor: theme.palette.primary.main
    },

    '.popularChip': {
      // position: 'absolute',
      // right: 5,
      // top: 7
      fontSize: '0.7rem',
      lineHeight: '0.9rem'
    },

    h1: {
      fontWeight: 'bold',
      fontSize: '1.3em',
      color: theme.palette.primary.main
    },

    h2: {
      fontWeight: 'bold',
      fontSize: '1.0em',
      color: theme.palette.primary.main
    },

    '.pricing': {
      fontWeight: 'normal'
    },

    '.description': {
      fontWeight: 'normal',
      fontSize: '0.9rem'
    },

    p: {
      // fontWeight: 'bold',
      // color: theme.palette.primary.main,
    }
  },

  iconButton: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    button: {
      flexDirection: 'column',
      width: 50,
      height: 50
    },
    flexBasis: '20%',
    span: {
      fontSize: 10
    }
  },

  videoContent: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100vh',
    marginTop: -20,
    padding: '0 30px 0 30px',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    zIndex: 3
  },

  cta: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 10px',

    [theme.breakpoints.up('md')]: {
      maxWidth: '50vw',
      padding: 0
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: 500,
      padding: 0
    },

    h1: {
      color: 'white',
      fontSize: '3.9rem',
      fontWeight: 900,
      lineHeight: '3.9rem',
      textShadow: '2px 2px rgb(0, 0, 0, 0.2)',

      '.bionic': {
        fontSize: '2.8rem',
        lineHeight: '2.8rem',
        fontWeight: 'normal',
        display: 'block',

        strong: {
          fontSize: '4.8rem',
          lineHeight: '4.8rem',
          display: 'block',

          [theme.breakpoints.down('sm')]: {
            fontSize: '4.1rem',
            lineHeight: '4.1rem'
          }
        }
      }
    },

    h4: {
      color: 'white',
      display: 'flex',
      fontSize: '2rem',
      lineHeight: '2.2rem',
      textShadow: '2px 2px rgb(0, 0, 0, 0.2)',
      fontWeight: 700,

      '.bionic': {
        fontSize: '2.3rem',
        lineHeight: '2.3rem',
        fontWeight: 'normal',
        display: 'inline',

        [theme.breakpoints.down('sm')]: {
          fontSize: '2rem',
          lineHeight: '2.2rem'
        },

        strong: {
          fontWeight: 1000
        }
      }
    }
  },

  inviteBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '.boxTitle': {
      color: 'white',
      fontSize: '2.8rem',
      fontWeight: 'bold',
      lineHeight: '2.8rem'
    },

    '.subTitle': {
      color: '#FFF',
      fontSize: '1.6rem',
      fontWeight: 'bold',
      marginTop: 10,
      lineHeight: '1.8rem'
    },

    '.coverBox': {
      position: 'relative',
      // maxWidth: 400,
      width: '100%',
      display: 'flex',
      margin: '14px auto 0 auto'
    },

    '.partnerLogo': {
      position: 'relative',
      maxWidth: 400,
      width: '100%',
      display: 'flex',
      height: 200,
      margin: '20px auto 0 auto',
      overflow: 'hidden',
      borderRadius: 8
    },

    p: {
      fontSize: '1.6rem',
      fontWeight: 'bold',
      color: '#FFF'
    }
  },

  theRest: {
    padding: 30
  },

  contentSection: {
    paddingTop: 50,
    paddingBottom: 30,
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',

    '.sectionTitle': {
      fontSize: '2.6rem',
      fontWeight: 'bold'
    },

    '.stepBox': {
      margin: '0 auto 20px auto',
      textAlign: 'center'
    },

    h1: {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '2.5em'
    },

    p: {
      textAlign: 'center'
      // fontWeight: 'bold',
      // fontSize: '1.5em'
    },

    '&.altBackround': {
      background: theme.palette.grey.light
      // paddingTop: 20
    },

    '&.padded': {
      paddingLeft: 20,
      paddingRight: 20
    }
  },

  featuresSection: {
    '.featureTile': {
      position: 'relative',
      margin: 'auto',
      textAlign: 'center',
      paddingBottom: 20,

      '.featureImage': {
        position: 'relative',
        borderRadius: 10,
        height: 280,
        overflow: 'hidden',
        marginBottom: 5
      }
    }
  },

  carousel: {
    display: 'block',
    // height: 200,
    borderRadius: 10,
    marginBottom: 15,

    '.carouselSlide': {
      position: 'relative',
      height: 200,
      width: '100%',

      '.carouselLabel': {
        fontSize: '1.1em',
        position: 'absolute',
        borderRadius: 10,
        bottom: 20,
        left: 20,
        padding: 20,
        color: '#FFF',
        textAlign: 'center',
        textShadow: '2px 2px rgba(0, 0, 0, 0.7)',
        background: 'rgba(0, 0, 0, 0.4)'
      }
    }
  },

  carouselChips: {
    marginBottom: 0,
    width: '100%',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',

    '.MuiChip-root': {
      marginBottom: 5
    }
  },

  sizeSelector: {
    background: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 10,
    padding: 20,
    textAlign: 'left',

    'h1.MuiTypography-bookPreview': {
      fontSize: '2.4em'
    }
  },

  // Home page (should be moved)
  playerWrapper: {
    position: 'relative',
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
    overflow: 'hidden',
    width: '100%',

    '.playerDarken': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 2,
      // right: 0,
      height: '100%',
      width: '100%',
      background: 'rgba(0, 0, 0, 0.5)'
    }
  },

  videoPlayer: {
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    height: '100%',

    '& video': {
      zIndex: 1,
      objectFit: 'cover',
      // height: '100vh',
      width: '100%'
    }
  },

  beforeAfterList: {
    width: '100%',

    '.imageTile': {
      padding: 12,
      width: '100%',
      cursor: 'pointer',
      borderRadius: 8,
      overflow: 'hidden',
      position: 'relative'
    }
  },

  aiScrollerWrapper: {
    backgroundImage: 'url("/img/marketing/landing/section_ai_art/table_bkgrnd.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    paddingTop: 0,
    paddingBottom: 0,
    position: 'relative',

    h3: {
      fontSize: '2.6rem',
      textAlign: 'center',
      lineHeight: '2.6rem'
    },

    h4: {
      fontSize: '1.8rem',
      lineHeight: '1.8rem',
      textAlign: 'center'
    },

    '.aiScroller': {
      minHeight: 500,
      width: '100%',
      display: 'flex',
      position: 'relative',

      '.messTop': {
        backgroundImage: 'url("/img/marketing/landing/section_ai_art/table_mess_top.png")',
        backgroundPosition: '80%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: 184
      },

      '.messBottom': {
        backgroundImage: 'url("/img/marketing/landing/section_ai_art/table_mess_bottom.png")',
        // backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: 185
      },

      '.characterBox': {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
        position: 'relative',
        flexDirection: 'column',

        '.aiGirl': {
          position: 'relative',
          display: 'flex',
          marginTop: 20,
          height: 510,
          width: 730,
          [theme.breakpoints.down(950)]: {
            height: 308,
            width: 700
          },
          [theme.breakpoints.down('md')]: {
            height: 308,
            width: 440
          },
          [theme.breakpoints.down('sm')]: {
            height: 189,
            width: 270
          }
        },

        '.bookTitle': {
          zIndex: 2,
          fontSize: '1.8rem',
          marginBottom: 30,
          textAlign: 'center',
          fontWeight: 'bold',

          p: {
            fontSize: '1.4rem',
            fontWeight: 'bold'
          },

          [theme.breakpoints.down('sm')]: {
            fontSize: '1.4rem',
            marginBottom: 20
          }
        },

        '.giftTag': {
          width: '80%',
          height: '100%',
          zIndex: 300,
          position: 'absolute',
          top: 0,
          overflow: 'hidden',
          textAlign: 'right',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'end',

          '.tagBox': {
            width: 319,
            height: 279,
            position: 'relative',

            [theme.breakpoints.down('sm')]: {
              width: 170,
              height: 148
            }
          }
        },

        '.book': {
          width: '80%',
          height: '100%',
          justifyContent: 'center',
          display: 'flex',
          borderRadius: 8,
          // margin: 20,
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',

          background: `
            linear-gradient(
              to right,
              rgba(0, 0, 0, 0.1) 3px,
              rgba(255, 255, 255, 0.5) 5px,
              rgba(255, 255, 255, 0.25) 7px,
              rgba(255, 255, 255, 0.25) 10px,
              transparent 12px,
              transparent 16px,
              rgba(255, 255, 255, 0.25) 17px,
              transparent 22px
            ),
            linear-gradient(
              to bottom right,
              rgba(255, 255, 255, 0.3),
              rgba(20, 20, 20, 0.2)
            ),
            #48767f`,
          boxShadow: `
              inset -2px 2px 4px rgba(255, 255, 255, 0.3),

              rgba(0, 0, 0, 0.4) 0px 2px 4px,
              rgba(0, 0, 0, 0.3) 0px 7px 13px -3px,
              rgba(0, 0, 0, 0.2) 0px -3px 0px inset,

              rgba(0, 0, 0, 0.35) 0px 15px 25px,
              rgba(0, 0, 0, 0.25) 0px 10px 25px,
              rgba(0, 0, 0, 0.25) 0px 10px 25px
          `
        }
      },

      '.subBookText': {
        marginTop: 50,
        marginBottom: 70,
        textAlign: 'center',
        paddingRight: 20,
        paddingLeft: 20
      }
    }
  },

  imperfectWrapper: {
    backgroundImage: 'url("/img/marketing/landing/section_imperfect/table_bkgrnd.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    paddingTop: 0,
    paddingBottom: 0,
    position: 'relative',

    '.imperfectSection': {
      minHeight: '100vh',
      position: 'relative',
      width: '100%',

      '.sectionText': {
        textAlign: 'left',
        position: 'absolute',
        bottom: 30,
        left: 0,
        width: '50%',
        padding: '0 30px 10px 30px',

        [theme.breakpoints.down('sm')]: {
          width: '100%'
        },

        h3: {
          fontSize: '2.8rem'
        },

        h4: {
          fontSize: '1.8rem',
          lineHeight: '1.8rem'
        }
      }
    },

    '.phoneSection': {
      position: 'absolute',
      right: 0,
      width: '100%',
      overflow: 'hidden',
      height: '100%',

      '.phoneBox': {
        width: 859,
        height: 519,
        position: 'absolute',
        right: 0,

        [theme.breakpoints.down('lg')]: {
          width: 600,
          height: 363
        },

        [theme.breakpoints.down('sm')]: {
          width: 360,
          height: 217
        }
      }
    }
  },

  peskySignup: {
    display: 'block',
    position: 'fixed',
    bottom: 0,
    right: 0,
    zIndex: 200,

    '.innerBox': {
      textAlign: 'center',
      color: 'white',
      background: theme.palette.primary.main,

      a: {
        marginTop: 0,
        fontSize: '1.2rem',
        color: '#FFF'
      }
    }
  },

  dealSection: {
    '.dealHeader': {
      fontWeight: 'bold',
      fontSize: '3.5rem',
      lineHeight: '3.6rem'
    },

    '.dealSubHeader': {
      fontWeight: 'bold',
      fontSize: '2rem',
      lineHeight: '2.6rem'
    },

    '.MuiCard-root': {
      padding: 0
    },

    '.productImage': {
      textAlign: 'center',

      '.imageBox': {
        margin: 'auto',
        position: 'relative'
      }
    },

    '.discountBadge': {
      position: 'absolute',
      height: 80,
      width: 80,
      top: 5,
      right: 10,
      background: theme.palette.primary.main,
      borderRadius: '50%',
      color: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      textAlign: 'center',
      flexDirection: 'column',
      boxShadow: `
        inset -2px 2px 4px rgba(255, 255, 255, 0.3),
        rgba(0, 0, 0, 0.4) 0px 2px 4px
      `,

      strong: {
        marginTop: 7,
        fontSize: '1.8em',
        lineHeight: '1.4rem'
      },
      small: {
        // display: 'block'
        lineHeight: '1.1rem'
      }
    },

    '.cartActions': {
      textAlign: 'center',
      padding: '0 30px 30px 30px',

      '.productTitle': {
        marginTop: 25,
        textAlign: 'left',
        marginBottom: 4,
        fontSize: '1.6rem',
        fontWeight: 'bold'
      },

      '.description': {
        textAlign: 'left',
        margin: '15px auto 15px auto',

        p: {
          textAlign: 'left'
        }
      },

      '.pricing': {
        textAlign: 'left',
        fontSize: '1.3rem'
      }
    }
  }
});

export default bookSizeDialogStyle;
